import { MyWorkPermit } from '../../work-permits/work-permits.interfaces';

export type MyWorkPermitsState = Readonly<{
  // null until loaded; [] also when loading failed or the module is disabled.
  myWorkPermits: MyWorkPermit[] | null;
  myWorkPermit: MyWorkPermit | null;
  loadingMyWorkPermit: boolean;
  removingFileIds: string[];
}>;

export const initialState: MyWorkPermitsState = {
  myWorkPermits: null,
  myWorkPermit: null,
  loadingMyWorkPermit: false,
  removingFileIds: [],
};
